import React from "react";

import Analytics from "../pages/layouts/dashboards/analytics";
import Sales from "../pages/layouts/dashboards/sales";
import ProfileOverview from "../pages/layouts/pages/profile/profile-overview";
import AllProjects from "../pages/layouts/pages/profile/all-projects";
import NewUser from "../pages/layouts/pages/users/new-user";
import Settings from "../pages/layouts/pages/account/settings";
import Billing from "../pages/layouts/pages/account/billing";
import Invoice from "../pages/layouts/pages/account/invoice";
import Timeline from "../pages/layouts/pages/projects/timeline";
import PricingPage from "../pages/layouts/pages/pricing-page";
import Widgets from "../pages/layouts/pages/widgets";
import RTL from "../pages/layouts/pages/rtl";
import Charts from "../pages/layouts/pages/charts";
import Notifications from "../pages/layouts/pages/notifications";
import Kanban from "../pages/layouts/applications/kanban";
import Wizard from "../pages/layouts/applications/wizard";
import DataTables from "../pages/layouts/applications/data-tables";
import Calendar from "../pages/layouts/applications/calendar";
import NewProduct from "../pages/layouts/ecommerce/products/new-product";
import EditProduct from "../pages/layouts/ecommerce/products/edit-product";
import ProductPage from "../pages/layouts/ecommerce/products/product-page";
import OrderList from "../pages/layouts/ecommerce/orders/order-list";
import OrderDetails from "../pages/layouts/ecommerce/orders/order-details";
import SignInBasic from "../pages/layouts/authentication/sign-in/basic";
import SignInCover from "../pages/layouts/authentication/sign-in/cover";
import SignInIllustration from "../pages/layouts/authentication/sign-in/illustration";
import SignUpCover from "../pages/layouts/authentication/sign-up/cover";
import ResetCover from "../pages/layouts/authentication/reset-password/cover";

import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/dashboards/analytics",
            component: (
                <Analytics />
            ),
            privacy: "private",
        },
        {
            route: "/dashboards/sales",
            component: <Sales />,
            privacy: "private",
        },
        {
            route: "/pages/profile/profile-overview",
            component: <ProfileOverview />,
            privacy: "private",
        },
        {
            route: "/pages/profile/all-projects",
            component: <AllProjects />,
            privacy: "private",
        },
        {
            route: "/pages/users/new-user",
            component: <NewUser />,
            privacy: "private",
        },
        {
            route: "/pages/account/settings",
            component: <Settings />,
            privacy: "private",
        },
        {
            route: "/pages/account/billing",
            component: <Billing />,
            privacy: "private",
        },
        {
            route: "/pages/account/invoice",
            component: <Invoice />,
            privacy: "private",
        },
        {
            route: "/pages/projects/timeline",
            component: <Timeline />,
            privacy: "private",
        },
        {
            route: "/pages/pricing-page",
            component: <PricingPage />,
            privacy: "private",
        },
        {
            route: "/pages/rtl",
            component: <RTL />,
            privacy: "private",
        },
        {
            route: "/pages/widgets",
            component: <Widgets />,
            privacy: "private",
        },
        {
            route: "/pages/charts",
            component: <Charts />,
            privacy: "private",
        },
        {
            route: "/pages/notifications",
            component: <Notifications />,
            privacy: "private",
        },
        {
            route: "/applications/kanban",
            component: <Kanban />,
            privacy: "private",
        },
        {
            route: "/applications/wizard",
            component: <Wizard />,
            privacy: "private",
        },
        {
            route: "/applications/data-tables",
            component: <DataTables />,
            privacy: "private",
        },
        {
            route: "/applications/calendar",
            component: <Calendar />,
            privacy: "private",
        },
        {
            route: "/ecommerce/products/new-product",
            component: <NewProduct />,
            privacy: "private",
        },
        {
            route: "/ecommerce/products/edit-product",
            component: <EditProduct />,
            privacy: "private",
        },
        {
            route: "/ecommerce/products/product-page",
            component: <ProductPage />,
            privacy: "private",
        },
        {
            route: "/ecommerce/orders/order-list",
            component: <OrderList />,
            privacy: "private",
        },
        {
            route: "/ecommerce/orders/order-details",
            component: <OrderDetails />,
            privacy: "private",
        },
        {
            route: "/authentication/sign-in/basic",
            component: <SignInBasic />,
            privacy: "public",
        },
        {
            route: "/authentication/sign-in/cover",
            component: <SignInCover />,
            privacy: "public",
        },
        {
            route: "/authentication/sign-in/illustration",
            component: <SignInIllustration />,
            privacy: "public",
        },
        {
            route: "/authentication/sign-up/cover",
            component: <SignUpCover />,
            privacy: "public",
        },
        {
            route: "/authentication/reset-password/cover",
            component: <ResetCover />,
            privacy: "public",
        },
    ]
};

export default routes;